import React from "react";
import { TypeAnimation } from "react-type-animation";
import resume from "../assets/Resume.pdf";

const HeroSection = () => {

  return (
    <section>
      <div className="grid grid-cols-1 sm:grid-cols-12">
        <div className="col-span-7 mt-12 place-self-center text-center sm:text-left">
          <h1 className="text-white mb-4 text-4xl  sm:text-5xl lg:text-6xl font-extrabold">
            <span className="text-transparent mb-4 bg-clip-text bg-gradient-to-br from-primary-200 via-secondary-400 to-third-800 hover:bg-slate-200 ">
              Hello, i'm{" "}
            </span>
            <br></br>
            <TypeAnimation
              sequence={[
                "Abdallah Gamal",
                2000,
                "Front-end Developer",
                1000,
                "Reacr.js - Tailwind css",
                1000,
              ]}
              wrapper="span"
              speed={50}
              style={{ fontSize: "3rem", display: "inline-block" }}
              repeat={Infinity}
            />
          </h1>
          <p className="text-[#ADB7BE] text-base sm:text-lg mb-6 lg:text-xl">
            Enthusiastic and self-motivated junior front-end developer with a
            strong passion for building responsive and user-friendly websites.
            Proficient in HTML, CSS, and JavaScript, with a solid understanding
            of front-end frameworks such as React. Strong problem-solving skills
            and the ability to learn new technologies quickly.
          </p>
          <div>
            <button className="px-6 py-3 rounded-full w-full sm:w-fit mr-4 font-bold text-3xl lg:text-lg bg-gradient-to-br from-teal-300 via-teal-500 to-teal-800 hover:bg-slate-200 text-white">
              <a href="https://wa.me/+201118211720">
                Hire Me
              </a>
            </button>
            <button className="px-1 py-1 rounded-full w-full sm:w-fit mr-4 bg-gradient-to-br from-teal-200 via-teal-500 to-teal-800 hover:bg-slate-800  text-white mt-3">
              <span className="block bg-[#121212] hover:bg-slate-800 rounded-full px-5 py-2">
                <a href={resume} download="Abdalla Gamal">
                  Download CV
                </a>
              </span>
            </button>
          </div>
        </div>
        <div className="col-span-5 place-self-center mt-4 lg:mt-0">
          <div className="rounded-full lg:ml-60 bg-[#181818] w-[300px] h-[300px] lg:w-[350px] lg:h-[350px] mt-20 relative">
            <img
              src={require("../images/hero-image.png")}
              alt="Logo"
              className="absolute transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2 rounded-full "
              width={320}
              height={320}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
